import { getWithAuth, postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

const getEndpoint = apiUrl + 'agentInsights/settings/attribution/';
const setEndpoint = apiUrl + 'agentInsights/settings/attribution/set/';

export interface AttributionSettingsResponse {
  success: boolean;
  /** true = facts-only books: a task's project counts only when it came from
   *  a linked tracker ticket; everything else shows as "Unallocated". */
  strictTicketAttribution?: boolean;
  error?: string | null;
  code?: string;
}

const parseResponse = async (
  response: Response
): Promise<AttributionSettingsResponse> => {
  if (!response.ok) {
    return { success: false, error: `HTTP ${response.status}` };
  }
  const data = await response.json();
  const parsed = typeof data === 'string' ? JSON.parse(data) : data;
  return parsed as AttributionSettingsResponse;
};

/** Read the org's spend-attribution mode. */
export const getAttributionSettings = async (
  orgUUID: string
): Promise<AttributionSettingsResponse> => {
  try {
    const response = await getWithAuth(`${getEndpoint}?OrgUUID=${orgUUID}`);
    return await parseResponse(response);
  } catch (error) {
    console.error('Failed to load attribution settings:', error);
    return { success: false, error: 'request_failed' };
  }
};

/** Set the org's spend-attribution mode (admin only). */
export const setAttributionSettings = async (
  orgUUID: string,
  strictTicketAttribution: boolean
): Promise<AttributionSettingsResponse> => {
  try {
    const response = await postWithAuth(setEndpoint, {
      OrgUUID: orgUUID,
      strictTicketAttribution,
    });
    return await parseResponse(response);
  } catch (error) {
    console.error('Failed to save attribution settings:', error);
    return { success: false, error: 'request_failed' };
  }
};
